import { AfterViewInit, DestroyRef, Directive, ElementRef, EventEmitter, Input, NgZone, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { WINDOW } from '@frontend/vanilla/core';
import { filter, fromEvent, merge } from 'rxjs';

@Directive({ selector: '[msOutsideInteraction]' })
export class OutsideInteractionDirective implements AfterViewInit {
    private elementRef = inject(ElementRef);
    private ngZone = inject(NgZone);

    @Output() msOutsideInteraction = new EventEmitter<void>();

    @Input() set msOutsideInteractionExclude(value: string) {
        this.excludeSelectors = (value || '').split(',');
    }

    private excludeSelectors: string[] | undefined = undefined;
    private readonly destroyRef = inject(DestroyRef);

    ngAfterViewInit(): void {
        const events = ['click'];

        this.ngZone.runOutsideAngular(() => {
            merge(...events.map((event) => fromEvent(this._window, event)))
                .pipe(
                    filter((e) => !this.isOwnClick(e)),
                    takeUntilDestroyed(this.destroyRef),
                )
                .subscribe(() => this.msOutsideInteraction.next());
        });
    }

    private isOwnClick(event: Event): boolean {
        const target = event.target as HTMLElement;
        let isOwnEvent = !!target && this.element.contains(target);

        if (!isOwnEvent && this.excludeSelectors) {
            this.excludeSelectors.forEach((selector) => (isOwnEvent = isOwnEvent || target.matches(selector)));
        }

        return isOwnEvent;
    }

    private get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    private readonly _window = inject(WINDOW);
}
